module.exports = __webpack_public_path__ + "static/heli-abbb9c06d2c21e434e507a42fa38cf68.svg";